import { Component, OnInit, Input, NO_ERRORS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  imports: [RouterModule, CommonModule],
  schemas: [NO_ERRORS_SCHEMA],
})
export class BreadcrumbComponent {
  [key: string]: any;
  constructor() {
  }

}
